import { NgModule } from "@angular/core";
import { IconSpriteModule } from "ng-svg-icon-sprite";

@NgModule({
  imports: [
    IconSpriteModule.forRoot({
      path: "assets/sprite/svg-set.svg?ts=" + Date.now(),
    }),
  ],
  exports: [IconSpriteModule],
})
export class SvgIconsModule {}
